import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import BeamIcon from 'beam/dist/BeamIcon'
import { IconButton } from 'beam/dist/Button'
import { withStyles } from 'beam/dist/styles'
import Typography from 'beam/dist/Typography'
import TextField from 'beam/dist/TextField'
import Paper from 'beam/dist/Paper'

const styles = theme => ({
  root: {
    alignSelf: 'flex-end',
    display: 'flex',
    flex: '1 0 auto',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  hidden: {
    display: 'none',
  },
  searchField: {
    flex: '1 1 auto',
    marginLeft: theme.spacing(1),
  },
  count: {
    flex: `0 0 ${theme.spacing(8)}px`,
    margin: theme.spacing(0, 1),
    textAlign: 'right',
  },
})

const Search = ({ classes, query, queryTotalHits, queryCurrentIndex, searchFor, goToQueryHit, t, open, onClose }) => {
  const nextHit = ({ key, shiftKey }) => {
    if (key === 'Enter') {
      const direction = shiftKey ? -1 : 1
      goToQueryHit(direction)
    }
  }

  const handleClose = () => {
    searchFor({ target: { value: '' } })
    onClose()
  }

  return (
    <Paper className={classNames(classes.root, !open && classes.hidden)} elevation={1} square>
      <TextField
        className={classes.searchField}
        placeholder={t('find')}
        value={query}
        InputProps={{
          disableunderline: 'true',
        }}
        onKeyDown={nextHit}
        onChange={searchFor}
      />
      {query.length !== 0 ? (
        queryTotalHits !== 0 ? (
          <Typography variant="caption" className={classes.count}>
            {`${queryCurrentIndex}/${queryTotalHits}`}
          </Typography>
        ) : (
          <Typography variant="caption" color="error" className={classes.count}>
            {t('noResults')}
          </Typography>
        )
      ) : (
        <Typography variant="caption" className={classes.count}>
          {t('noResults')}
        </Typography>
      )}
      <IconButton disabled={queryTotalHits === 0} onClick={() => goToQueryHit(-1)}>
        <BeamIcon>ChevronUp</BeamIcon>
      </IconButton>
      <IconButton disabled={queryTotalHits === 0} onClick={() => goToQueryHit(1)}>
        <BeamIcon>ChevronDown</BeamIcon>
      </IconButton>
      <IconButton onClick={handleClose}>
        <BeamIcon>Close</BeamIcon>
      </IconButton>
    </Paper>
  )
}

Search.propTypes = {
  classes: PropTypes.object.isRequired,
  // data
  query: PropTypes.string.isRequired,
  queryTotalHits: PropTypes.number.isRequired,
  queryCurrentIndex: PropTypes.number.isRequired,
  // callbacks
  searchFor: PropTypes.func.isRequired,
  goToQueryHit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default withStyles(styles)(withTranslation()(Search))
